// src/hooks/useAnalytics.js
import { useCallback, useEffect } from 'react';
import { 
  trackPageView, 
  // googleAnalytic,
   googleAnalyticEnhanced, trackButtonClick
   } from '../utils/analytics';

export const useAnalytics = () => {
  // Page view tracking
  const useTrackPageView = () => {
    useEffect(() => {
      trackPageView(window.location.pathname + window.location.search);
    }, []);
  };

  // Event tracking with your existing signature
  // const trackEvent = useCallback(async (flName, category, action, label, value) => {
  //   return await googleAnalytic(flName, category, action, label, value);
  // }, []);

  // Enhanced event tracking
  const trackEventEnhanced = useCallback(async (flName, category, action, label, value, additionalParams = {}) => {
    return await googleAnalyticEnhanced(flName, category, action, label, value, additionalParams);
  }, []);

  
  // Specific event types
  const trackStaffEvent = useCallback(async (action, label, additionalData = {}) => {
    const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
    
    return await googleAnalyticEnhanced(
      "createStaff",
      'Staff',
      action,
      label,
      1,
      {
        gym_id: userInfo.gymid,
        user_email: userInfo.email,
        ...additionalData
      }
    );
  }, []);

  const trackMemberEvent = useCallback(async (action, label, additionalData = {}) => {
    const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
    
    return await googleAnalyticEnhanced(
      "CreateMember",
      'Members',
      action,
      label,
      1,
      {
        gym_id: userInfo.gymid,
        user_email: userInfo.email,
        ...additionalData
      }
    );
  }, []);

  return {
    useTrackPageView,
    // trackEvent,
    trackEventEnhanced,
    trackStaffEvent,
    trackMemberEvent,
    trackButtonClick
  };
};